import React from "react";
import styled from "styled-components";

export default styled.section`
    padding: 20px;
    height: 77px;
    background: white;
    // border-bottom: 1px solid #979797;
    `;